wbApp.controller('HeaderCtrl', ['$scope', '$timeout', '$translate', 'languageService', 'messageBoxSvc', 'securitySvc', '$modal',
  function ($scope, $timeout, $translate, languageService, messageBoxSvc, securitySvc, $modal) {

      $scope.currentLanguage = languageService.currentLanguage();
      $scope.isAuthenticated = securitySvc.isAuthenticated();

      $scope.changeLanguage = function (langKey) {
          languageService.currentLangKey(langKey);
          location.reload();
          //$scope.currentLanguage = languageService.currentLanguage();
          //$scope.supportedLanguagesDropdown.length = 0;
          //fillLanguagesDropdown(languageService.supportedLanguages);
      };

      $scope.supportedLanguagesDropdown = [];
      fillLanguagesDropdown(languageService.supportedLanguages)

      $scope.toggleAssideNavigation = function () {
          $('body').toggleClass("hidden-menu");
          $timeout(function () {
              $('body').resize();
          }, 100);
      }

      $scope.signOut = function () {
          messageBoxSvc.showMessageDlg({
              title: 'TXT_TITLE_CONFIRMATION',
              message: 'TXT_SIGN_OUT_CONFIRMATION',
              buttons: [{
                  text: 'TXT_BTN_CANCEL'
              }, {
                  text: 'TXT_CMD_SIGN_OUT',
                  callback: function () { securitySvc.adminLogout(); }
              }]
          });
      }


      function fillLanguagesDropdown(supportedLanguages) {
          angular.forEach(supportedLanguages, function (lang, key) {
              var item = {
                  "text": "<img height='14px' alt='' src='" + lang.img + "'>&nbsp;&nbsp;" + $translate.instant(lang.nameResID),
                  "click": 'changeLanguage("' + lang.key + '")'
              }
              this.push(item);
          }, $scope.supportedLanguagesDropdown);
      }

      var signInDialogPromise = $modal({
          templateUrl: 'sign-in/sign-in-dialog.html',
          show: false,
          scope: $scope.$new()
      });
      
      $scope.signIn = function() {
          signInDialogPromise.$promise.then(function () {
              signInDialogPromise.$scope.isAdmin = true;
              signInDialogPromise.show();
          });     
      }
      
      if (!$scope.isAuthenticated) {
          signInDialogPromise.$promise.then(function () {
              signInDialogPromise.$scope.isAdmin = true;
              signInDialogPromise.show();
          });
      }



  }]);